import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, TabContent, TabPane, Button } from 'reactstrap'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { licenseShape } from '../../../../lib/shapes'
import { ErrorBoundary } from 'components'

export default class LicenseActions extends React.Component {
  static propTypes = {
    skus: PropTypes.arrayOf(PropTypes.object),
    license: licenseShape.isRequired,
    onReset: PropTypes.func.isRequired,
    onRenew: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }
  static defaultProps = {
    availableSkus: [],
  }

  static Tabs = {
    Renew: 1,
    Change: 2,
    Cancel: 3,
  }

  constructor(props) {
    super(props)
    this.state = {
      activeTab: 0,
    }
  }

  setCurrentTab = tabId => {
    if (this.state.activeTab === tabId) {
      this.setState({ activeTab: 0 })
      this.props.onReset(this.props.license.licenseId)
    } else this.setState({ activeTab: tabId })
  }

  onChangeSku = e => {
    const newSku = e.currentTarget.value
    this.props.onChange(this.props.license.licenseId, newSku)
  }

  onCancel = date => {
    const value = moment(date).format('YYYY-MM-DD')
    this.props.onCancel(this.props.license.licenseId, value)
  }

  render = () => {
    const { activeTab } = this.state
    const { props } = this
    const canRenew = !!props.skus.find(s => s.sku === props.license.sku)
    const availableSkus = props.skus.filter(
      s => s.skuCode !== props.license.skuCode,
    )
    const canChange = availableSkus.length > 0

    return (
      <ErrorBoundary>
        <Row className="mt-4">
          {canRenew && (
            <Col>
              <Button
                color="success"
                block
                outline={canRenew && activeTab !== LicenseActions.Tabs.Renew}
                onClick={() => {
                  if (activeTab !== LicenseActions.Tabs.Renew) {
                    props.onRenew(props.license.licenseId)
                  }
                  this.setCurrentTab(LicenseActions.Tabs.Renew)
                }}
              >
                Renew
              </Button>
            </Col>
          )}
          {canChange && (
            <Col>
              <Button
                color="warning"
                block
                outline={activeTab !== LicenseActions.Tabs.Change}
                onClick={() => this.setCurrentTab(LicenseActions.Tabs.Change)}
              >
                Change
              </Button>
            </Col>
          )}
          <Col>
            <Button
              color="danger"
              block
              outline={activeTab !== LicenseActions.Tabs.Cancel}
              onClick={() => this.setCurrentTab(LicenseActions.Tabs.Cancel)}
            >
              Cancel
            </Button>
          </Col>
        </Row>
        <TabContent activeTab={activeTab}>
          <br />
          <TabPane tabId={LicenseActions.Tabs.Renew}>
            <p>This license will be renewed without product changes.</p>
          </TabPane>
          <TabPane tabId={LicenseActions.Tabs.Change}>
            <p>Select the new product for this license.</p>
            <select onBlur={this.onChangeSku}>
              <option />
              {availableSkus.map(sku => (
                <option key={sku.sku} value={sku.sku}>
                  {sku.sku} - {sku.name}
                </option>
              ))}
            </select>
          </TabPane>
          <TabPane tabId={LicenseActions.Tabs.Cancel}>
            <p>Enter the effective cancelation date.</p>
            <DatePicker
              autoComplete="off"
              className="form-control"
              dateFormat="yyyy-MM-dd"
              placeholderText="effective date"
              onChange={date => this.onCancel(date)}
            />
          </TabPane>
        </TabContent>
      </ErrorBoundary>
    )
  }
}
